import Plot from "react-plotly.js";
import { useMemo } from "react";
import { DEFAULT_RESPONSE_UNITS } from "../constants";
function linspace(start, stop, n) {
    if (n === 1) return [start];
    const step = (stop - start) / (n - 1);
    return Array.from({ length: n }, (_, i) => start + (step * i));
}

function SimulatedStudyPlot({ percentiles, doses, show, doseUnit, endpoint, plotting=null }) {
  const data = useMemo(() => {
    return [
      {
        type: "scatter",
        y: percentiles.map((d) => d[1]),
        x: doses.map((d) => d.dose),
        mode: plotting == null ? 'lines+markers': 'markers',
        error_y: {
          type: "data",
          array: percentiles.map((d) => d[2] - d[1]),
          arrayminus: percentiles.map((d) => d[1] - d[0]),
          thickness: 2,
          width: 6,
          color: "rgba(153,153,153,0.8)",
        },

        marker: {
          color: "rgba(15,138,117,0.8)",
        },
      },
    ];
  }, [percentiles, doses, plotting]);
  let response_unit = endpoint in DEFAULT_RESPONSE_UNITS ? DEFAULT_RESPONSE_UNITS[endpoint] : "Incidence Rate"
  const layout = {
    showlegend: false,
    xaxis: {
      title: {text: `Dose (${doseUnit})`},
      ticksuffix: ` ${doseUnit}`,
    },

    yaxis: {
      title: {text:`Response (${response_unit})`},
    },
  };
  if (!show) {
    return null;
  }
  if(plotting!=null){
    let x_doses = linspace(0, 1, 100).map(x=>x*Math.max(...doses.map((d) => d.dose)))
    data.push({
       type: "scatter",
        y: plotting.mid,
        x: x_doses,
        mode: 'lines',
        marker: {
          color: "rgba(0, 186, 172,0.8)",
        },
    });
    data.push({
       type: "scatter",
        y: plotting.upper,
        x: x_doses,
        mode: 'lines',
        marker: {
          color: "rgba(166, 98, 104, 0.8)",
        },
    });
    data.push({
       type: "scatter",
        y: plotting.lower,
        x: x_doses,
        mode: 'lines',
        marker: {
          color: "rgba(166, 98, 104, 0.8)",
        },
        
    });
  }
  

  return (
    <Plot
      data={data}
      layout={layout}
      style={{
        width: "40vw",
        height: "40vh",
        
      }}
      config={{ staticPlot: true }}
      useResizeHandler
    />
  );
}

export default SimulatedStudyPlot;
